module.exports = __webpack_public_path__ + "static/img_2246_optimized-79c75a4a1904c526ea7617dec5831926.jpg";